import { buildPath } from "./buildPath";

const externalBaseUrl = "/marketing_emails/marketing_email_preference";
const internalBaseUrl = "/internal_api/marketing_email_preference";

export type AccessType = "internal" | "external";

const getBaseUrl = (accessType: AccessType) =>
  accessType === "internal" ? internalBaseUrl : externalBaseUrl;

export const marketingEmailPreferences = {
  show: (accessType: AccessType, { params = {} } = {}) =>
    buildPath(getBaseUrl(accessType), params),
  upsert: (accessType: AccessType, { params = {} } = {}) =>
    buildPath(`${getBaseUrl(accessType)}/upsert`, params),
};
